// extracted by mini-css-extract-plugin
module.exports = {"text":"SelectStreets_text__2SHeq","city":"SelectStreets_city__1OwZt","name":"SelectStreets_name__36f86"};